import React, { useState } from 'react';
import {
	CancellationData,
	withCancellationContext,
} from '../../context/CancellationProvider';
import { BodyContainer, LayoutContainer, TopContainer } from '../common';
import LargeCenterSpinner from '../LargeCenterSpinner';
import ReinstatementActions from '../policy/Actions/ReinstatementActions';
import Breadcrumbs from '../policy/Cancellations/ReinstatementBreadcrumbs';
import ReinstatementOverview from '../policy/Cancellations/ReinstatementOverview';

interface Props {
	children?: JSX.Element | JSX.Element[];
	cancellationData: CancellationData;
}

const ReinstatementLayout = (props: Props) => {
	const { cancellationData } = props;
	const [loading, setLoading] = useState<boolean>(false);
	props.cancellationData.setLoading = setLoading;

	if (!cancellationData) {
		return <LargeCenterSpinner />;
	}

	return (
		<>
			{loading ? <LargeCenterSpinner /> : null}
			<TopContainer>
				<Breadcrumbs />
				<ReinstatementActions />
			</TopContainer>
			<LayoutContainer>
				<BodyContainer>
					<ReinstatementOverview />
					{props.children}
				</BodyContainer>
			</LayoutContainer>
		</>
	);
};

export default withCancellationContext<Props>(ReinstatementLayout);
